export default "__VITE_ASSET__31a25147__"